// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import ldverEntity from './entities/ldver.json';
import ldverMenu from '../pages/ldver/menu.json';
import ldverFullForm from '../pages/ldver/forms/full.json';
import ldverContextForm from '../pages/ldver/forms/context.json';
import ldverMiniForm from '../pages/ldver/forms/mini.json';
import ldverLookupForm from '../pages/ldver/forms/lookup.json';
import ldverTableView from '../pages/ldver/views/table.json';
import ldverStagesView from '../pages/ldver/views/stages.json';
import ldverCardsView from '../pages/ldver/views/cards.json';
import ldverInlineView from '../pages/ldver/views/inline.json';
import ldverBacklogView from '../pages/ldver/views/backlog.json';
import ldverSplitView from '../pages/ldver/views/split.json';
import ldverCalendarView from '../pages/ldver/views/calendar.json';
import ldverDashboardView from '../pages/ldver/views/dashboard.json';

/** Тип запису «Версія» зі сторінками пакета: меню, форми та подання з pages/ldver/. */
export const ldverDefinition: IRecordTypeDefinition = {
  ...ldverEntity,
  views: assembleViewSet({
      table: ldverTableView,
      stages: ldverStagesView,
      cards: ldverCardsView,
      inline: ldverInlineView,
      backlog: ldverBacklogView,
      split: ldverSplitView,
      calendar: ldverCalendarView,
      dashboard: ldverDashboardView,
  }),
  form: ldverFullForm,
  forms: { full: ldverFullForm, context: ldverContextForm, mini: ldverMiniForm, lookup: ldverLookupForm },
  menu: ldverMenu,
} as IRecordTypeDefinition;
